// extracted by mini-css-extract-plugin
module.exports = {"icon":"clinical-portal-3__Icon__icon","button":"clinical-portal-3__Icon__button","fixed":"clinical-portal-3__Icon__fixed"};